import request from '@/utils/request'

export function updateAreaCfgCfg(data) {
  return request({
    url: 'api/v1/area/updateCfg',
    method: 'post',
    data: data
  })
}

export function updateSieveAreaCfgCfg(data) {
  return request({
    url: 'api/v1/area/updateSieveAreaCfg',
    method: 'post',
    data: data
  })
}

export function updateShieldsAreaCfgCfg(data) {
  return request({
    url: 'api/v1/area/updateShieldsAreaCfg',
    method: 'post',
    data: data
  })
}

export function updateAnimalCfg(data) {
  return request({
    url: 'api/v1/area/updateAnimalCfg',
    method: 'post',
    data: data
  })
}

export function updateSieveCfg(data) {
  return request({
    url: 'api/v1/area/updateSieveCfg',
    method: 'post',
    data: data
  })
}

export function updateShieldsCfg(data) {
  return request({
    url: 'api/v1/area/updateShieldsCfg',
    method: 'post',
    data: data
  })
}

export function exportBeastJson(data) {
  return request({
    url: 'api/v1/export/makeSieveJson',
    method: 'post',
    data: data
  })
}

export function deleteAnimalCfg(data) {
  return request({
    url: 'api/v1/area/delAnimalCfg',
    method: 'delete',
    data: data
  })
}

export function deleteShieldsCfg(data) {
  return request({
    url: 'api/v1/area/delShieldsCfg',
    method: 'delete',
    data: data
  })
}

export function deleteSieveCfg(data) {
  return request({
    url: 'api/v1/area/delSieveCfg',
    method: 'delete',
    data: data
  })
}

export function getAreaCfgList(data) {
  return request({
    url: 'api/v1/area/getCfg',
    method: 'post',
    data: data
  })
}

export function getSieveAreaCfgList(data) {
  return request({
    url: 'api/v1/area/getSieveAreaCfg',
    method: 'post',
    data: data
  })
}

export function getShieldsAreaCfgList(data) {
  return request({
    url: 'api/v1/area/getShieldsAreaCfg',
    method: 'post',
    data: data
  })
}

export function getAnimalList(data) {
  return request({
    url: 'api/v1/area/getAnimalCfg',
    method: 'post',
    data: data
  })
}

export function getAbilityConfig(data) {
  return request({
    url: 'api/v1/area/getBeastAbilityCfg',
    method: 'post',
    data: data
  })
}

export function getShieldsList(data) {
  return request({
    url: 'api/v1/area/getShieldsCfg',
    method: 'post',
    data: data
  })
}

export function getSieveList(data) {
  return request({
    url: 'api/v1/area/getSieveCfg',
    method: 'post',
    data: data
  })
}

export function getAnimalAllList() {
  return request({
    url: 'api/v1/area/getAnimalAllCfg',
    method: 'post'
  })
}

export function getSieveAllList() {
  return request({
    url: 'api/v1/area/getSieveAllCfg',
    method: 'post'
  })
}

export function getShieldsAllList() {
  return request({
    url: 'api/v1/area/getShieldsAllCfg',
    method: 'post'
  })
}

export function getAreaCfgAll() {
  return request({
    url: 'api/v1/area/getCfgAll',
    method: 'get'
  })
}

export function exportAnimalCfg() {
  return request({
    url: 'api/v1/area/exportAnimalCfg',
    method: 'post'
  })
}

export function exportShieldCfg() {
  return request({
    url: 'api/v1/area/exportShieldsCfg',
    method: 'post'
  })
}

export function exportSieveCfg() {
  return request({
    url: 'api/v1/area/exportSieveCfg',
    method: 'post'
  })
}

export function importAnimalCfg(data) {
  return request({
    url: 'api/v1/area/importAnimalCfg',
    method: 'post',
    data: data
  })
}

export function importShieldsCfg(data) {
  return request({
    url: 'api/v1/area/importShieldsCfg',
    method: 'post',
    data: data
  })
}

export function importAreaCfg(data) {
  return request({
    url: 'api/v1/area/importAreaCfg',
    method: 'post',
    data: data
  })
}

export function importSieveAreaCfg(data) {
  return request({
    url: 'api/v1/area/importSieveAreaCfg',
    method: 'post',
    data: data
  })
}

export function exportAreaCfg() {
  return request({
    url: 'api/v1/area/exportAreaCfg',
    method: 'post'
  })
}

export function exportSieveAreaCfg() {
  return request({
    url: 'api/v1/area/exportSieveAreaCfg',
    method: 'post'
  })
}

export function exportShieldsAreaCfg() {
  return request({
    url: 'api/v1/area/exportShieldsAreaCfg',
    method: 'post'
  })
}

export function exportJson() {
  return request({
    url: 'api/v1/area/makeJson',
    method: 'get'
  })
}

